import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}
export function Textarea({
  className = '',
  error,
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-677">
      <textarea className={`
          flex min-h-[100px] sm:min-h-[120px] w-full rounded-lg border-2 border-amber-200 bg-white 
          px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base text-stone-800 placeholder:text-stone-400
          focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500
          disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-stone-50
          transition-all duration-200 resize-y
          print:min-h-[80px] print:text-sm print:border-stone-400 print:rounded-md
          ${error ? 'border-red-500 focus:ring-red-500 bg-red-50/30' : ''}
          ${className}
        `} {...props} data-id="element-678" />
      {error && <p className="mt-1.5 text-xs sm:text-sm text-red-600 font-medium print:hidden" data-id="element-679">
          {error}
        </p>}
    </div>;
}